import { useState, useEffect } from 'react';
import { fetchTotalCountsAction } from '../../actions/dashboardActions';
import { toast } from 'react-toastify';

/**
 * Dashboard statistics configuration
 */
export const dashboardStatsConfig = [
    {
        key: 'totalClients',
        title: 'Total Clients',
        icon: '👥',
        color: '#4a90e2',
        description: 'Total number of registered clients'
    },
    {
        key: 'totalVendors',
        title: 'Total Vendors',
        icon: '🏢',
        color: '#f39c12',
        description: 'Total number of registered vendors'
    },
    {
        key: 'totalPendings',
        title: 'Pending',
        icon: '📊',
        color: '#e74c3c',
        description: 'Total pending items'
    }
];

/**
 * Get formatted stat value
 * @param {number} value - The stat value
 * @param {boolean} isLoading - Loading state
 * @returns {string} Formatted value
 */
export const getFormattedStatValue = (value, isLoading) => {
    if (isLoading) return '...';
    if (value === null || value === undefined) return '0';
    return value.toString();
};

/**
 * Custom hook to fetch and manage dashboard counts
 * @returns {Object} Dashboard counts state and loading status
 */
export const useDashboardCounts = () => {
    const [counts, setCounts] = useState({
        totalClients: 0,
        totalVendors: 0,
        totalPendings: 0
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadDashboardCounts = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetchTotalCountsAction();

            if (response.success) {
                setCounts(response.data);
            } else {
                const errorMsg = response.message || "Failed to load dashboard counts";
                setError(errorMsg);
                toast.error(errorMsg);
            }
        } catch (err) {
            console.error("Error loading dashboard counts:", err);
            const errorMsg = "Failed to load dashboard counts";
            setError(errorMsg);
            toast.error(errorMsg);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadDashboardCounts();
    }, []);

    return {
        counts,
        isLoading,
        error,
        refetch: loadDashboardCounts
    };
};



export const getStatsArray = (counts, isLoading) => {
    return dashboardStatsConfig.map(config => ({
        ...config,
        value: getFormattedStatValue(counts[config.key], isLoading)
    }));
};

